// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__arSqL","footer":"ModalFilter_footer__2ArDc"};